import { ModifyUser } from "../user/modifyUser";
var InstantMessageChannelInvitation = /** @class */ (function () {
    function InstantMessageChannelInvitation(obj) {
        this.id = obj && obj.id || "";
        this.sender = new ModifyUser(obj ? obj.sender : null);
    }
    InstantMessageChannelInvitation.prototype.getHash = function () {
        return this.id + "#" + this.sender.code;
    };
    return InstantMessageChannelInvitation;
}());
export { InstantMessageChannelInvitation };
